// eslint-disable-next-line no-restricted-imports
import {
  SaveIncomeSourcesDto_Input,
  MutationInput_ClientController_UpdateById_Input_IncomeSources_IncomeSources_Items as IncomeSourcesApi,
  MutationInput_ClientController_UpdateById_Input_IncomeSources_Occupation as OccupationTypeApi,
} from 'api/generated/graphql';
import {
  SourcesOfIncomeOccupationType,
  SourcesOfIncomeSourceType,
} from 'api/types/entity';
import { ClientSaveSourcesOfIncomeParam } from 'api/types/params';

const incomeSources: Record<SourcesOfIncomeSourceType, IncomeSourcesApi> = {
  [SourcesOfIncomeSourceType.Salary]: IncomeSourcesApi.Salary,
  [SourcesOfIncomeSourceType.Savings]: IncomeSourcesApi.Savings,
  [SourcesOfIncomeSourceType.Inheritance]: IncomeSourcesApi.Inheritance,
  [SourcesOfIncomeSourceType.BusinessActivity]: IncomeSourcesApi.BusinessIncome,
  [SourcesOfIncomeSourceType.Other]: IncomeSourcesApi.Other,
};

const occupationTypes: Record<
  SourcesOfIncomeOccupationType,
  OccupationTypeApi
> = {
  [SourcesOfIncomeOccupationType.Employee]: OccupationTypeApi.Employee,
  [SourcesOfIncomeOccupationType.IndividualEntrepreneur]:
    OccupationTypeApi.Entrepreneur,
  [SourcesOfIncomeOccupationType.BusinessOwner]:
    OccupationTypeApi.BusinessOwner,
  [SourcesOfIncomeOccupationType.Student]: OccupationTypeApi.Student,
  [SourcesOfIncomeOccupationType.Retiree]: OccupationTypeApi.Retired,
  [SourcesOfIncomeOccupationType.Unemployed]: OccupationTypeApi.Unemployed,
  [SourcesOfIncomeOccupationType.Other]: OccupationTypeApi.Other,
};

export const parseSaveSourcesOfIncomeParam = (
  data: ClientSaveSourcesOfIncomeParam
): SaveIncomeSourcesDto_Input => ({
  incomeSources: data.incomeSources.map((v) => incomeSources[v]),
  otherIncomeSource: data.otherIncomeSource || null,
  occupation: occupationTypes[data.occupation],
  otherOccupation: data.otherOccupation || null,
  workplaceName: data.workplaceName || null,
  position: data.position || null,
  confirmationFileIds_Global: data.confirmationFileIds_Global,
});
